import { useQueryClient, useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { ErrorResponse } from "react-router-dom";
import { translate } from "shared/languages";
import { getApiSuccessMessage, getApiErrorMessage } from "shared/utils";
import client from "shared/utils/axios-config";
import { invalidateCustomerList } from "hooks/mutations/customerList";

// NOTE (package-products restructure): package create/update/delete moved to
// the product mutations (hooks/mutations/product.ts) — a tier is only ever
// written through its product. Buying still posts the TIER id.
const useBuyPackageByPackageId = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({
      packageId,
      customerId,
      paymentMethodId,
      discountCode,
    }: {
      packageId: string;
      customerId: string;
      paymentMethodId?: string;
      // Kode Diskon. The server re-resolves it inside the purchase
      // transaction — the validate call is only for showing the admin a
      // preview, never the source of the price actually charged.
      discountCode?: string;
    }) => {
      return client.post(`/v1/package/buy/${packageId}`, {
        customer_id: customerId,
        payment_method_id: paymentMethodId,
        discount_code: discountCode,
      });
    },
    onSuccess: () => {
      // Invalidate the whole customer_package namespace: the client-detail
      // package lists AND the schedule/booking credit pickers
      // (["customer_package","group",...] / ["customer_package",{...}]) so an
      // inline purchase from the schedule drawer shows up immediately.
      queryClient.invalidateQueries({ queryKey: [`customer_package`] });
      // The Klien list's "Paket Tersisa" count changes with a purchase.
      invalidateCustomerList(queryClient);
      getApiSuccessMessage(`${translate("messages.success.buy_package")}`);
    },
    onError: (error: AxiosError<ErrorResponse>) => {
      getApiErrorMessage(error);
    },
  });
};

export { useBuyPackageByPackageId };
